import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { DatabankModel } from '../models/DataBankModel';
import { URLsConfig } from '../URLsConfig';

@Injectable()
export class DataBankService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }
    public getPatient(patientCode: string , comCode: string) {
      let params = new HttpParams();
        params = params.append("patientCode", patientCode);
        params = params.append("compCode", comCode);
        const options = {
            params: params
        };
        return this.http.get<DatabankModel>(this.urlsconfig.WebAPIURL_Test + 'api/DataBank/GetDatabank',options);
    }
    public getNextSerial(yearEntry: string , comCode: string) {
      let params = new HttpParams();
        console.log("serv.yearEntry", yearEntry)
        params = params.append("cuurentyear", yearEntry);
        params = params.append("compCode", comCode);
        const options = {
            params: params
        };
        return this.http.get<DatabankModel>(this.urlsconfig.WebAPIURL_Test + 'api/DataBank/PatSerial',options);
    }
    public AddPatient(PatientData: DatabankModel) {
        
        return this.http.post<DatabankModel>(this.urlsconfig.WebAPIURL_Test + 'api/DataBank/AddDatabank', PatientData);
    }
    public UpdatePatient(PatientData: DatabankModel) {

      return this.http.post<DatabankModel>(this.urlsconfig.WebAPIURL_Test + 'api/DataBank/UpdateDatabank', PatientData);
  }
    public UpdatePatientReferd(patientCode: string , referedfrom: string, compCode: string) {
     debugger; 
       let params = new HttpParams();
        params = params.append("patientCode", patientCode);
        params = params.append("referredfrom", referedfrom);
        params = params.append("cmpCode", compCode);
        const options = {
          params: params
      };
      return this.http.get<DatabankModel>(this.urlsconfig.WebAPIURL_Test + 'api/DataBank/UpdateReferdDatabank', options);
  }
    public delPatient(patientCode: string , compCode: string) {

      let params = new HttpParams();
        params = params.append("patientCode", patientCode);
        params = params.append("compCode", compCode);
        const options = {
          params: params
      };
      return this.http.get<DatabankModel>(this.urlsconfig.WebAPIURL_Test + 'api/DataBank/Deletedatabank',options);
    }

    public getPatientLookup(patientCode: string, PatientFName: string,telMobile:string,telHome:string,telBusin:string, cancerID:string , compCode: string) {
      let params = new HttpParams();
      params = params.append("patientCode", patientCode);
      params = params.append("PatientFName", PatientFName);
      params = params.append("telMobile", telMobile);
      params = params.append("telHome", telHome);
      params = params.append("telBusin", telBusin);
      params = params.append("cancerId", cancerID);

      params = params.append("compCode", compCode);
      const options = {
          params: params
      };
      return this.http.get<DatabankModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/DataBank/DatabackLookup', options);
  }
  public getPatientBirthLookup(birtdate: string, compCode: string) {
    let params = new HttpParams();
    params = params.append("BirtDate", birtdate);
    params = params.append("compCode", compCode);
    const options = {
        params: params
    };
    return this.http.get<DatabankModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/DataBank/DatabackBirthLookup', options);
}

    public getpatientLookupTop(compCode: string) {
      let params = new HttpParams();
      params = params.append("compCode", compCode);
      const options = {
          params: params
      };
      return this.http.get<DatabankModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/DataBank/DatabankLookupTop', options);
  }
}
